app_url += "portal/";
var outageChart, rolling30Chart;

$("document").ready(function () {

	//CALENDAR
	if ($("#calendar").length) {
		initCalendar();
		socket.on("calendar:App\\Events\\CalendarHandler", function (data) {
			$("#calendar").fullCalendar('refetchEvents');
		});
	}

	//APPS
	if ($("#app").length) {
		// console.log("APP");
		$("#search-apps").on("blur change keyup", searchApps);
		$("#new-app").click(createApp);
		$("#app-list a").click(editApp);
	}

	//USERS
	if ($("#user").length) {
		// console.log("USERS");
		$("#search-users").on("blur change keyup", searchUsers);
		$("#user-list a").click(editUser);
	}

	//Outage chart
	if ($("#outage-chart").length)
		initOutageChart();

	//Rolling 30 chart
	if ($("#rolling-30").length)
		initRolling30();

	//Announcements and Events
	$("#new-announcement").click(newAnnouncement);
	$("a.announcement").click(getAnnouncement);
	$("#new-event").click(newEvent);
});

/**
 * Searches a list of apps, filtering ones that don't match the criteria
 */
function searchApps() {
	var search = $(this).val().toUpperCase();
	$("#app-list a").each(function () {
		if ($(this).text().toUpperCase().indexOf(search) > -1)
			$(this).slideDown(200);
		else
			$(this).slideUp(200);
	});
}

/**
 * Gets the form for creating an app
 */
function createApp() {
	$.ajax({
		url: app_url + "management/apps/create",
		dataType: 'html',
		success: function (html) {
			$("#app").html(html);
			$("#add-users-app").click(addUsers);
			$("#remove-users-app").click(removeUsers);
			$("#store-app").click(storeApp);
		}
	});
}

/**
 * Stores the newly created app in the database
 */
function storeApp(e) {
	e.preventDefault();

	var postData = {
		_token: token(),
		id: $("[name='id']").val(),
		name: $("[name='name']").val(),
		url: $("[name='url']").val(),
		category_id: $("[name='category_id']").val(),
		open: $("[name='open']").is(":checked"),
		listed: $("[name='listed']").is(":checked"),
		app_users: []
	};

	// console.log("STORE FUCKING APP");
	// console.log(postData);

	$("[name='app-users[]'] option").each(function () {
		postData.app_users.push($(this).val());
	});

	$.ajax({
		url: app_url + "management/apps",
		method: 'POST',
		dataType: 'json',
		data: postData,
		success: function (json) {
			if (json)
				window.location.reload();
		}
	});
}

/**
 * Gets the form for editing an application
 */
function editApp() {
	$.ajax({
		url: app_url + "management/apps/" + $(this).data("id") + "/edit",
		dataType: 'html',
		success: function (html) {
			$("#app").html(html);
			$("#add-users-app").click(addUsers);
			$("#remove-users-app").click(removeUsers);
			$("#delete-app").click(deleteApp);
			$("#save-app").click(updateApp);
		}, error: function () {

		}
	});
}

/**
 * Updates an existing app
 * @param e
 */
function updateApp(e) {
	e.preventDefault();
	var postData = {
		_token: $("[name='_token']").val(),
		id: $("[name='id']").val(),
		name: $("[name='name']").val(),
		url: $("[name='url']").val(),
		category_id: $("[name='category_id']").val(),
		open: $("[name='open']").is(":checked"),
		listed: $("[name='listed']").is(":checked"),
		users: [],
		app_users: []
	};
	$("[name='app-users[]'] option").each(function () {
		postData.app_users.push($(this).val());
	});
	$("[name='users[]'] option").each(function () {
		postData.users.push($(this).val());
	});

	$("#app-update-form .form-control").attr("disabled", "disabled");

	$.ajax({
		url: app_url + "management/apps/update",
		method: 'PUT',
		dataType: 'json',
		data: postData,
		success: function (json) {
			if (json)
				$("#app-update-form .form-control").attr("disabled", null);
			else
				errorMsg('//TODO', '//TODO');
		},
		error: function () {
		}
	});
}

/**
 * Deletes an app
 */
function deleteApp() {
	$.ajax({
		url: app_url + "management/apps/" + $(this).data("id"),
		method: 'DELETE',
		dataType: 'json',
		data: {
			_token: $("[name='_token']").val()
		},
		success: function (json) {
			if (json)
				window.location.reload();
			else
				errorMsg("AJAX Error", "Could not delete application.");
		}
	});
}

/**
 * Searches a list of apps, filtering ones that don't match the criteria
 */
function searchUsers() {
	var search = $(this).val().toUpperCase();
	$("#user-list a").each(function () {
		if ($(this).text().toUpperCase().indexOf(search) > -1)
			$(this).slideDown(200);
		else
			$(this).slideUp(200);
	});
}

/**
 * Gets the for for editing a user
 */
function editUser() {
	$.ajax({
		url: app_url + "management/users/" + $(this).data("id") + "/edit",
		dataType: 'html',
		success: function (html) {
			$("#user").html(html);
			$("#add-apps-user").click(addApps);
			$("#remove-apps-user").click(removeApps);
			$("#add-roles-user").click(addRoles);
			$("#remove-roles-user").click(removeRoles);
			$("#save-user").click(updateUser);
		}
	})
}

/**
 * Updates a user
 * @param e
 */
function updateUser(e) {
	e.preventDefault();
	var postData = {
		_token: $("[name='_token']").val(),
		id: $("[name='id']").val(),
		first_name: $("[name='first_name']").val(),
		last_name: $("[name='last_name']").val(),
		title: $("[name='title']").val(),
		group_id: $("[name='group_id']").val(),
		email: $("[name='email']").val(),
		phone: $("[name='phone']").val(),
		emergency_phone: $("[name='emergency_phone']").val(),
		extension: $("[name='extension']").val(),
		apps: [],
		user_apps: [],
		roles: [],
		user_roles: []
	};
	$("[name='apps[]'] option").each(function () {
		postData.apps.push($(this).val());
	});
	$("[name='user-apps[]'] option").each(function () {
		postData.user_apps.push($(this).val());
	});
	$("[name='roles[]'] option").each(function () {
		postData.roles.push($(this).val());
	});
	$("[name='user-roles[]'] option").each(function () {
		postData.user_roles.push($(this).val());
	});

	$("#user-update-form .form-control").attr("disabled", "disabled");
	$.ajax({
		url: app_url + "management/users/" + postData.id,
		method: 'PUT',
		dataType: 'json',
		data: postData,
		success: function(json) {
			$(".has-error").removeClass('has-error');
			$("#user-update-form .form-control").attr("disabled", null);
		},
		error: function(data) {

			$("#user-update-form .form-control").attr("disabled", null);

			$(".edit-user").each(function(index) {
				$(this).removeClass('has-error');
			});

			$.each(data.responseJSON, function(key, val) {
				$("#" + key).parent().addClass('has-error');
			});

		}
	});
}

/**
 * Adds apps to the user
 */
function addApps() {
	$("[name='apps[]'] option:selected").each(function () {
		var append = $(this).clone();
		$("[name='user-apps[]']").append(append);
		$(this).remove();
	});
}

/**
 * Removes apps from the user
 */
function removeApps() {
	$("[name='user-apps[]'] option:selected").each(function () {
		var append = $(this).clone();
		$("[name='apps[]']").append(append);
		$(this).remove();
	});
}

/**
 * Adds users to the app
 */
function addUsers() {
	$("[name='users[]'] option:selected").each(function () {
		var append = $(this).clone();
		$("[name='app-users[]']").append(append);
		$(this).remove();
	});
}

/**
 * Removes users from the app
 */
function removeUsers() {
	$("[name='app-users[]'] option:selected").each(function () {
		var append = $(this).clone();
		$("[name='users[]']").append(append);
		$(this).remove();
	});
}

/**
 * Adds roles to the user
 */
function addRoles() {
	$("[name='roles[]'] option:selected").each(function () {
		var append = $(this).clone();
		$("[name='user-roles[]']").append(append);
		$(this).remove();
	});
}

/**
 * Removes Roles from the user
 */
function removeRoles() {
	$("[name='user-roles[]'] option:selected").each(function () {
		var append = $(this).clone();
		$("[name='roles[]']").append(append);
		$(this).remove();
	});
}

function dateFromDay(year, day) {
	var date = new Date(year, 0); // initialize a date in `year-01-01`
	return new Date(date.setDate(day)); // add the number of days
}

/**
 * Opens the form to create a new event
 */
function newEvent() {
	$.ajax({
		url: app_url + "events/create",
		dataType: 'html',
		success: function (html) {
			$("#event-modal").html(html);
			$("#event-modal button.submit").click(createEvent);
			$("#event-modal").modal('show');
		},
		error: function (xhr, status, error) {
			errorMsg("AJAX Error: " + status, error);
		}
	});
}

/**
 * Creates an event
 */
function createEvent() {
	var postData = $("#event-modal form").serialize() + "&_token=" + token();
	$.ajax({
		url: app_url + "events",
		dataType: 'json',
		data: postData,
		method: 'PUT',
		success: function (json) {
			$("#calendar").fullCalendar('refetchEvents');
			$("#event-modal").modal("hide");
		}
	});
}

/**
 * Gets an event for editing
 * @param event
 */
function getEvent(event) {
	$.ajax({
		url: app_url + "events/" + event.id + "/edit",
		dataType: 'html',
		success: function (html) {
			$("#event-modal").html(html);
			$("#event-modal button.submit").click(updateEvent);
			$("#event-modal button.delete").click(deleteEvent);
			$("#event-modal").modal('show');
		},
		error: function (xhr, status, error) {
			errorMsg("AJAX Error: " + status, error);
		}
	});
}

/**
 * Updates an edited event
 * @param event
 * @param delta
 */
function updateEvent(event, delta) {
	var postData;
	if (typeof event !== 'undefined' && typeof delta !== 'undefined')
		postData = {
			id: event.id,
			days: delta._days,
			months: delta._months,
			_token: token()
		};
	else
		postData = $("#event-modal form").serialize();
	$.ajax({
		url: app_url + "events/update",
		dataType: 'json',
		data: postData,
		method: 'POST',
		success: function (json) {
			$("#event-modal").modal("hide");
		}
	});
}

/**
 * Deletes an event
 */
function deleteEvent() {
	var postData = $("#event-modal form").serialize();
	$.ajax({
		url: app_url + "events/" + $("#event-modal input[name='id']").val(),
		dataType: 'json',
		data: postData,
		method: 'DELETE',
		success: function (json) {
			$("#event-modal").modal("hide");
		}
	});
}

/**
 * Opens the form for creating a new announcement
 */
function newAnnouncement() {
	$.ajax({
		url: app_url + "announcements/create",
		dataType: 'html',
		success: function (html) {
			$("#announcement-modal").html(html);
			$("#announcement-modal button.submit").click(createAnnouncement);
			$("#announcement-modal").modal('show');
		},
		error: function (xhr, status, error) {
			errorMsg("AJAX Error: " + status, error);
		}
	});
}

/**
 * Stores the newly created announcement
 */
function createAnnouncement() {
	var postData = $("#announcement-modal form").serialize();
	$.ajax({
		url: app_url + "announcements",
		dataType: 'json',
		data: postData,
		method: 'PUT',
		success: function (json) {
			if (json.hasOwnProperty("error"))
				errorMsg("AJAX Error: ", json.error);
			else
				location.reload();
		}
	});
}

/**
 * Get an announcement for editing
 */
function getAnnouncement() {
	$.ajax({
		url: app_url + "announcements/" + $(this).data("id") + "/edit",
		dataType: 'html',
		success: function (html) {
			$("#announcement-modal .modal-body").html(html);
			$("#announcement-modal button.submit").click(updateAnnouncement);
		}
	});
}

/**
 * Updates an edited announcement
 */
function updateAnnouncement() {
	var postData = $("#announcement-modal form").serialize();
	$.ajax({
		url: app_url + "announcements/update",
		method: 'POST',
		dataType: 'json',
		data: postData,
		success: function (json) {
			if (json.hasOwnProperty("error"))
				errorMsg("AJAX Error", json.error);
			else
				$("")
		}
	})
}

/**
 * Initializes the portal home page calendar
 */
function initCalendar() {
	$('#calendar').fullCalendar({
		header: {
			left: 'prev,next today',	//Show prev, next, today buttons
			center: 'title',			//Show the title
			right: 'month,basicDay'	//Show the month and week buttons
		},
		height: 770,
		editable: true,					//Can edit events
		droppable: true,				//Can drop things in calendar
		defaultView: 'month',
		events: function (start, end, timezone, callback) {
			$.ajax({
				url: app_url + 'events/feed/' + start.unix() + "/" + end.unix(),
				dataType: 'json',
				data: {},
				success: function (events) {
					callback(events);
				},
				error: function (xhr, status, error) {
					errorMsg("AJAX Error: " + status, error);
				}
			});
		},

		eventClick: function (event) {
			if (event.id != -1)
				getEvent(event);
		},

		eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
			if (event.id != -1)
				updateEvent(event, delta);
		},

		eventResize: function (event, delta, revertFunc, jsEvent, ui, view) {

		},

		dayClick: function (date, allDay, jsEvent, view) {

		},

		windowResize: function (view) {
			resizeCalendar();
		}

	});
	resizeCalendar();
}

/**
 * TODO something something resizes calendar
 */
function resizeCalendar() {
	if ($(window).width() <= 992)
		$("#calendar").fullCalendar('changeView', 'basicDay')
	else
		$("#calendar").fullCalendar('changeView', 'month')
}

/**
 * Get the data for the chart for outages
 */
function initOutageChart() {
	$.ajax({
		url: base_url + "/noc/service-issue/historygraph",
		dataType: 'json',
		success: function (json) {
			if (json.hasOwnProperty("error"))
				errorMsg("AJAX Error", json.error);
			else
				drawOutageChart(json);
		}
	});
}

/**
 * Draws the outage chart
 * @param json
 */
function drawOutageChart(json) {

	var outageData = {
		labels: json.x,
		datasets: [
			{
				label: "Outages",
				strokeColor: "#FF0000",
				fillColor: "rgba(255,0,0,0.5)",
				data: json.y
			}
		]
	};

	var ctx = $("#outage-chart").get(0).getContext("2d");
	outageChart = new Chart(ctx).Line(outageData, {});
}

/**
 * Gets the data for and draws the rolling 30 chart
 */
function initRolling30() {
	var data = {
		labels: [new Date().toLocaleDateString()],
		datasets: [
			{
				data: [$("#rolling-30").data("installs")],
				strokeColor: "rgba(39,174,96,1)",
				fillColor: "rgba(39,174,96,1)",
				highlightFill: "rgba(39,174,96,0.8)",
				highlightStroke: "rgba(39,174,96,0.8)",
				label: "Installs"
			},
			{
				data: [$("#rolling-30").data("surveys")],
				strokeColor: "rgba(41,128,185,1)",
				fillColor: "rgba(41,128,185,1)",
				highlightFill: "rgba(41,128,185,0.8)",
				highlightStroke: "rgba(41,128,185,0.8)",
				label: "Surveys"
			},
			{
				data: [$("#rolling-30").data("repairs")],
				strokeColor: "rgba(230,126,34,1)",
				fillColor: "rgba(230,126,34,1)",
				highlightFill: "rgba(230,126,34,0.8)",
				highlightStroke: "rgba(230,126,34,0.8)",
				label: "Repairs"
			},
			{
				data: [$("#rolling-30").data("removals")],
				strokeColor: "rgba(192,57,43,1)",
				fillColor: "rgba(192,57,43,1)",
				highlightFill: "rgba(192,57,43,.8)",
				highlightStroke: "rgba(192,57,43,.8)",
				label: "Removals"
			}
		]
	};

	var options = {
		scaleBeginAtZero: true,
		scaleShowGridLines: true,
		scaleGridLineColor: "rgba(0,0,0,.05)",
		scaleGridLineWidth: 1,
		scaleShowHorizontalLines: true,
		scaleShowVerticalLines: true,
		barShowStroke: true,
		barStrokeWidth: 2,
		barValueSpacing: 5,
		barDatasetSpacing: 1,
		responsive: true
	};

	var ctx = $("#rolling-30").get(0).getContext("2d");
	rolling30Chart = new Chart(ctx).Bar(data, options);
}